import React from 'react';
import { TabsOption } from 'global';
import { TabsContainer } from 'components/shared/TabsContainer/TabsContainer';
import { SummaryTab } from './tabs/summary/SummaryTab';
import { ProposalsByUser } from './tabs/proposalsByUser/ProposalsByUser';
import { TotalMarkupByLocation } from './tabs/totalMarkupByLocation/TotalMarkupByLocation';
import { ProposalVolumeOverTime } from './tabs/proposalVolumeOverTime/ProposalVolumeOverTime';
import { HighestResult, PeriodVolume, ProposalByLocation, ProposalByUser, ProposalSummary } from './DashboardPage';

interface Props {
  isLoading: boolean;
  dailyVolume: PeriodVolume[];
  weeklyVolume: PeriodVolume[];
  monthlyVolume: PeriodVolume[];
  proposalByUser: ProposalByUser[];
  proposalSummary: ProposalSummary[];
  proposalByLocation: ProposalByLocation[];
  summaryHighestResultData: HighestResult | null;
}

export const DashboardContent = ({
  isLoading,
  dailyVolume,
  weeklyVolume,
  monthlyVolume,
  proposalByUser,
  proposalSummary,
  proposalByLocation,
  summaryHighestResultData,
}: Props) => {
  const tabs: TabsOption[] = [
    {
      value: '1',
      label: 'Summary',
      component: (
        <SummaryTab
          isLoading={isLoading}
          proposalSummary={proposalSummary}
          summaryHighestResultData={summaryHighestResultData}
        />
      ),
    },
    {
      value: '2',
      label: 'Proposals by User',
      component: <ProposalsByUser dataset={proposalByUser} />,
    },
    {
      value: '3',
      label: 'Total Markup by Location',
      component: <TotalMarkupByLocation dataset={proposalByLocation} />,
    },
    {
      value: '4',
      label: 'Proposal Volume Over Time',
      component: (
        <ProposalVolumeOverTime dailyVolume={dailyVolume} weeklyVolume={weeklyVolume} monthlyVolume={monthlyVolume} />
      ),
    },
  ];

  return <TabsContainer tabs={tabs} />;
};
